import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  name: "Sarah Jenkins",
  location: "Walnut Creek",
  quote: "Katie was absolutely magical! The kids were mesmerized for the entire hour. It was the most stress-free birthday party we've ever hosted.",
  rating: 5
}, {
  name: "Michael Torres",
  location: "San Ramon",
  quote: "\"Katie brings the perfect balance of structure and creativity. Our corporate holiday party felt polished but still engaging and memorable. Professional, enchanting, and truly unique, the party was a massive hit thanks to Katie. Highly recommended!\"",
  rating: 5
}, {
  name: "Emily Richardson",
  location: "Danville",
  quote: "\"We hired Abracadabra Events for a paint party and it was incredible. Organized, creative, and genuinely fun. Our guests are still talking about it. A truly premium experience.\"",
  rating: 5
}, {
  name: "Jessica Lee",
  location: "Lafayette",
  quote: "\"Our fundraiser was truly FUN, thanks to Katie. I've never experienced a party that ran so smoothly. From setup to cleanup, everything was stress-free and beautifully executed. Katie brought so much joy and sparkle to the event. Pure magic!\"",
  rating: 5
}, {
  name: "David Chen",
  location: "Pleasant Hill",
  quote: "\"Katie made my daughter's birthday completely magical. I didn't have to worry about a single detail — she handled everything and the kids were thrilled! Katie has such a wonderful, gentle presence with the children! We will definitely use her again!\"",
  rating: 5
}];
export default function KindWordsStardust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="kind-words-stardust" className="bg-transparent relative overflow-hidden py-24 sm:py-32">
      <div className="bg-secondary/20 absolute -top-24 -left-24 h-96 w-96 rounded-full blur-3xl" />
      <div className="bg-secondary/10 absolute -bottom-24 -right-24 h-96 w-96 rounded-full blur-3xl" />

      <div className="container relative mx-auto px-4">
        <div ref={ref} className={`mb-16 text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="text-primary font-serif text-5xl font-normal sm:text-6xl">
            Kind Words & Stardust
          </h2>
          <p className="font-sans mx-auto mt-4 max-w-2xl text-lg !text-[hsl(0,0%,100%)] !italic sm:text-2xl">Hear from our delighted clients <br />about their magical experiences with Abracadabra Events.</p>
        </div>

        <div className="mx-auto max-w-5xl">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 pb-10">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="h-full p-1">
                    <Card className="bg-white/20 border-secondary/30 backdrop-blur-md relative flex h-full flex-col justify-between border shadow-xl transition-transform duration-300 hover:-translate-y-1">
                      <CardContent className="flex flex-col gap-6 p-8">
                        <div className="flex gap-1">
                          {Array.from({
                        length: testimonial.rating
                      }).map((_, starIndex) => <Star key={starIndex} className="text-secondary h-5 w-5 fill-current" />)}
                        </div>

                        <div className="relative">
                          <Quote className="text-secondary/20 absolute -top-2 -left-2 h-8 w-8 -scale-x-100 transform" />
                          <p className="font-sans text-primary relative z-10 text-lg italic leading-relaxed text-center">
                            "{testimonial.quote}"
                          </p>
                        </div>

                        <div className="mt-auto flex items-center justify-between gap-4 pt-4">
                          <div className="font-sans text-primary text-lg font-semibold tracking-wide uppercase">
                            {testimonial.name}
                          </div>
                          <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm">
                            {testimonial.location}
                          </Badge>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            <div className="hidden md:block">
              <CarouselPrevious className="bg-primary text-primary-foreground hover:bg-primary/90 border-primary/20 -left-12 h-12 w-12 border-2 shadow-md transition-colors" />
              <CarouselNext className="bg-primary text-primary-foreground hover:bg-primary/90 border-primary/20 -right-12 h-12 w-12 border-2 shadow-md transition-colors" />
            </div>
            
            <div className="mt-8 flex justify-center gap-4 md:hidden">
               <CarouselPrevious className="bg-primary text-primary-foreground hover:bg-primary/90 border-primary/20 static h-12 w-12 translate-y-0 border-2 shadow-md transition-colors" />
               <CarouselNext className="bg-primary text-primary-foreground hover:bg-primary/90 border-primary/20 static h-12 w-12 translate-y-0 border-2 shadow-md transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}